import dayjs from 'dayjs';

import { DATE_FORMAT } from '#client/constants/date';
import useCardsContext from '#client/hooks/useCardsContext';

const EMPTY_CARD = {
  id: '',
  holder: { firstName: '', lastName: '' },
  expirationDate: '',
  address: { postalCode: '' }
};

export default function useCardInfo() {
  const { virtualCard } = useCardsContext();
  const { id, holder, expirationDate, address } = virtualCard || EMPTY_CARD;
  const expiry = dayjs(expirationDate).format(DATE_FORMAT.VIRTUAL_CARD);
  const { postalCode } = address || {};

  const { firstName, lastName } = holder || { firstName: '', lastName: '' };
  const cardholder = `${firstName} ${lastName}`;

  return { cardholder, expiry, postalCode, id };
}
